import React from 'react';
import { IconUserStar } from '@tabler/icons-react';
import { BoardClickUpFilterChipDropdown } from './BoardClickUpFilterChipDropdown';

/** Chip "Coordenador" estilo ClickUp — submenu Board (teste A/B ao lado do chip legado). */
export function BoardToolbarCoordenadorClickUpChip(props) {
  return (
    <BoardClickUpFilterChipDropdown
      {...props}
      label="Coordenador"
      icon={IconUserStar}
      pickerMode="simple"
      pickerWidth={238}
      pickerMaxHeight={320}
      searchPlaceholder="Buscar"
      countLabel="coordenadores"
      listAriaLabel="Coordenadores"
      popoverClassName="board-search-filters-popover--coordenador"
      emptyMessage="Nenhum coordenador encontrado"
    />
  );
}
